import dayjs from 'dayjs'
import { object } from 'prop-types'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import {
  AcceptNowContainer,
  AcceptedNotAcceptedContainer,
  MentorLegalListItem,
  MentorLegalListItemTitle,
} from './styledComponents'

export default function LegalListItem({ item, onClick, mentorProfileData }) {
  const navigate = useNavigate()

  const titleToShow = useMemo(() => {
    return getAllRolesInBoolean().isDoctor || mentorProfileData?.categories?.includes('doctor')
      ? item?.title?.replace('Therapist', 'Doctor')
      : item?.title
  }, [item.title, mentorProfileData])

  function openLegalPolicy() {
    console.log(item)
    onClick ? onClick(item?.agreementId) : navigate(item?.agreementId)
  }

  return (
    <MentorLegalListItem accepted={item?.signed} onClick={openLegalPolicy}>
      <MentorLegalListItemTitle>{titleToShow}</MentorLegalListItemTitle>
      <AcceptNowContainer>
        <span>Last Updated</span>
        <span>{dayjs(item?.applicableSince).format('MMMM D, YYYY, h:mm A')}</span>
      </AcceptNowContainer>
      {item?.signed ? (
        <>
          <AcceptedNotAcceptedContainer accepted>Accepted</AcceptedNotAcceptedContainer>
          <AcceptNowContainer>
            <span>Accepted On</span>
            <span>{dayjs(item?.acceptedTime).format('MMMM D, YYYY, h:mm A')}</span>
          </AcceptNowContainer>
        </>
      ) : (
        <>
          <AcceptedNotAcceptedContainer>Not Accepted</AcceptedNotAcceptedContainer>
          <AcceptNowContainer>View and Accept</AcceptNowContainer>
        </>
      )}
    </MentorLegalListItem>
  )
}

LegalListItem.propTypes = {
  item: object,
}
